import {
  Black,
  BlackOpacity04,
  Gray20,
  Gray30,
  Gray100,
  White,
  typeCompact12RegularProperties,
  typeCompact14MediumProperties,
  typeCompact20DisplayProperties,
  typeMono20DisplayProperties,
  typeCompact24DisplayProperties,
  typeCompact10MediumCapsProperties,
  typeMono14MediumProperties,
  typeCompact14RegularProperties,
} from '@traceair/tds';
import { BREAKPOINT_SMALL } from '../../../../components/layout/styles';
import { media, stylesheet } from 'typestyle';

export const sharedInvoicingCss = stylesheet({
  pageTitle: {
    ...typeCompact24DisplayProperties,
    color: Black,
    margin: 0,
    flex: 1,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
    ...media({ maxWidth: BREAKPOINT_SMALL }, { ...typeCompact20DisplayProperties }),
  },
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    paddingTop: 24,
    paddingBottom: 32,
    maxWidth: 720,
    margin: '0 auto',
  },
  pageHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  periodSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  periodLabel: {
    ...typeCompact10MediumCapsProperties,
    color: Gray100,
  },
  costCard: {
    backgroundColor: White,
    border: `1px solid ${Gray20}`,
    borderRadius: 12,
    overflow: 'hidden',
  },
  sectionChevron: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    pointerEvents: 'none',
  },
  sectionTitleGroup: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
  },
  sectionTitle: {
    ...typeCompact14MediumProperties,
    color: Black,
  },
  sectionSubtitle: {
    ...typeCompact12RegularProperties,
    color: Gray100,
  },
  sectionAmount: {
    ...typeMono14MediumProperties,
    color: Black,
    flexShrink: 0,
  },
  sectionAmountZero: {
    ...typeMono14MediumProperties,
    color: Gray100,
    flexShrink: 0,
  },
  sectionItemsContainer: {
    backgroundColor: White,
  },
  emptySectionMsg: {
    margin: 0,
    padding: '10px 24px 10px 56px',
    color: Gray100,
    borderBottom: `1px solid ${BlackOpacity04}`,
    ...typeCompact14RegularProperties,
  },
  emptyStateContainer: { borderBottom: `1px solid ${Gray30}` },
  lineItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 20px 10px 56px',
    borderBottom: `1px solid ${BlackOpacity04}`,
    $nest: {
      '&:first-child': { borderTop: `1px solid ${Gray30}` },
      '&:last-child': { borderBottom: 'none' },
    },
  },
  itemAmount: {
    ...typeMono14MediumProperties,
    color: Black,
    textAlign: 'right' as const,
    minWidth: 50,
  },
  cardDivider: {
    height: 1,
    backgroundColor: Gray20,
    margin: '0 0',
  },
  customFieldRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 20px 8px 20px',
    gap: 12,
    borderBottom: `1px solid ${BlackOpacity04}`,
    $nest: {
      '&:last-of-type': { borderBottom: 'none' },
    },
  },
  customFieldInfo: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
  },
  customFieldLabel: {
    ...typeCompact14MediumProperties,
    color: Black,
  },
  customFieldDesc: {
    ...typeCompact12RegularProperties,
    color: Gray100,
  },
  otherSectionHeader: {
    padding: '12px 20px',
  },
  otherSectionHeaderEditable: {
    padding: '12px 24px 12px 20px',
  },
  otherSectionHeaderExpanded: {
    borderBottom: 'none',
  },
  totalRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
  },
  totalLabel: {
    ...typeCompact20DisplayProperties,
    color: Black,
  },
  totalAmount: { ...typeMono20DisplayProperties, color: Black },
  outerSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  outerSectionHead: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  outerSectionTitle: {
    ...typeCompact14MediumProperties,
    color: Black,
  },
  outerSectionSubtitle: {
    ...typeCompact12RegularProperties,
    color: Gray100,
  },
  removeItemBtn: {
    borderRadius: 8,
    backdropFilter: 'blur(12.5px)',
  },
  otherInputRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '12px 0',
  },
  priceInputContainer: {
    flexGrow: 1,
    justifyItems: 'flex-end',
    $nest: {
      '& input': {
        textAlign: 'right' as const,
      },
      '& .ta-text-input': {
        width: 90,
      },
      '& .ta-text-input div': {
        top: 12,
      },
    },
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
    paddingTop: 4,
  },
  footerNoteWrap: {
    flex: 1,
  },
  footerNote: {
    ...typeCompact12RegularProperties,
    margin: 0,
    color: Gray100,
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 24px 12px 20px',
    backgroundColor: White,
    cursor: 'pointer',
    borderBottom: `1px solid ${Gray30}`,
    $nest: {
      '&:hover': { backgroundColor: BlackOpacity04 },
    },
    ...media({ maxWidth: BREAKPOINT_SMALL }, { padding: '10px 12px' }),
  },
});
